<script lang="ts">
  import { isPresent } from '@yp/common/identity.ts';
  import * as qrcode from 'qrcode';
  import { Canvas, type CanvasDrawParams } from './canvas.ts';

  interface Props {
    text: string;
    clazz?: string | undefined;
    // N.B. Colors must be in hex format.
    dark?: string | undefined;
    light?: string | undefined;
  }

  const { text, clazz = undefined, dark = undefined, light = undefined }: Props = $props();

  function draw({ canvas, width, height }: CanvasDrawParams) {
    const size = Math.min(width, height);
    // console.log('QRCode', { width, height, cw: canvas.width, size });
    qrcode.toCanvas(canvas, text, { margin: 2, width: size, color: { dark, light } }, (error) => {
      if (isPresent(error)) {
        console.warn('QRCode error', { text, error });
      }
    });
  }
</script>

<Canvas clazz={`w-full h-full ${clazz ?? ''}`} {draw} />
